export type NetworkState = {
    error: NetworkErrors;
    loadingDashboardInit: boolean;
};

export enum NetworkErrors {
    SessionTimeout,
}
